export enum RouteAddressType {
    START = 'START',
    FINAL = 'FINAL',
  }